var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c("v-text-field", {
                    ref: "FabricanteSoftware",
                    attrs: {
                      label: "Fabricante Software",
                      counter: "",
                      maxlength: "80",
                      "prepend-inner-icon": "mdi-button-pointer",
                      required: "",
                    },
                    model: {
                      value: _vm.fabricante,
                      callback: function ($$v) {
                        _vm.fabricante = $$v
                      },
                      expression: "fabricante",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8" } },
                [
                  _c("v-text-field", {
                    ref: "RazonSocial",
                    attrs: {
                      label: "Razón Social",
                      counter: "",
                      maxlength: "80",
                      "prepend-inner-icon": "mdi-warehouse",
                      required: "",
                    },
                    model: {
                      value: _vm.razon_social,
                      callback: function ($$v) {
                        _vm.razon_social = $$v
                      },
                      expression: "razon_social",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c("v-text-field", {
                    ref: "Nit",
                    attrs: {
                      label: "Nit",
                      counter: "",
                      maxlength: "15",
                      "prepend-inner-icon": "mdi-card-account-details",
                      required: "",
                    },
                    model: {
                      value: _vm.nit,
                      callback: function ($$v) {
                        _vm.nit = $$v
                      },
                      expression: "nit",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8" } },
                [
                  _c("v-text-field", {
                    ref: "Distribuidor",
                    attrs: {
                      label: "Distribuidor",
                      counter: "",
                      maxlength: "80",
                      "prepend-inner-icon": "mdi-badge-account",
                      required: "",
                    },
                    model: {
                      value: _vm.distribuidor,
                      callback: function ($$v) {
                        _vm.distribuidor = $$v
                      },
                      expression: "distribuidor",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  staticStyle: {
                    "background-color": "rgb(204 33 40)",
                    color: "white !important",
                  },
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.updateDataFabricante()
                    },
                  },
                },
                [_vm._v(" Actualizar ")]
              ),
            ],
            1
          ),
          _c(
            "v-alert",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.successAlert,
                  expression: "successAlert",
                },
              ],
              attrs: { type: "success", text: "" },
            },
            [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }